import { match } from "ts-pattern";

import MappingMethodAutoIntrospectDark from "@gx/dls/assets/components/projects/MappingMethodAutoIntrospectDark";
import MappingMethodAutoIntrospectLight from "@gx/dls/assets/components/projects/MappingMethodAutoIntrospectLight";
import MappingMethodBlankDark from "@gx/dls/assets/components/projects/MappingMethodBlankDark";
import MappingMethodBlankDarkHovered from "@gx/dls/assets/components/projects/MappingMethodBlankDarkHovered";
import MappingMethodBlankLight from "@gx/dls/assets/components/projects/MappingMethodBlankLight";
import MappingMethodBlankLightHovered from "@gx/dls/assets/components/projects/MappingMethodBlankLightHovered";
import MappingMethodJsonDark from "@gx/dls/assets/components/projects/MappingMethodJsonDark";
import MappingMethodJsonDarkHovered from "@gx/dls/assets/components/projects/MappingMethodJsonDarkHovered";
import MappingMethodJsonLight from "@gx/dls/assets/components/projects/MappingMethodJsonLight";
import MappingMethodJsonLightHovered from "@gx/dls/assets/components/projects/MappingMethodJsonLightHovered";
import { GalaxyTheme, useGalaxyTheme } from "@gx/dls/theme";

interface MappingMethodCardGraphicProps {
  isHovered: boolean;
}

export const MappingMethodCardAutoIntrospectGraphic = () => {
  const { galaxyTheme } = useGalaxyTheme();

  return match(galaxyTheme)
    .returnType<React.ReactNode>()
    .with(GalaxyTheme.DARK, () => {
      return <MappingMethodAutoIntrospectDark />;
    })
    .with(GalaxyTheme.LIGHT, () => {
      return <MappingMethodAutoIntrospectLight />;
    })
    .exhaustive();
};

export const MappingMethodCardJsonGraphic = ({ isHovered }: MappingMethodCardGraphicProps) => {
  const { galaxyTheme } = useGalaxyTheme();

  if (galaxyTheme === GalaxyTheme.DARK) {
    if (isHovered) {
      return <MappingMethodJsonDarkHovered />;
    }
    return <MappingMethodJsonDark />;
  }
  if (isHovered) {
    return <MappingMethodJsonLightHovered />;
  }
  return <MappingMethodJsonLight />;
};

export const MappingMethodCardBlankGraphic = ({ isHovered }: MappingMethodCardGraphicProps) => {
  const { galaxyTheme } = useGalaxyTheme();

  if (galaxyTheme === GalaxyTheme.DARK) {
    if (isHovered) {
      return <MappingMethodBlankDarkHovered />;
    }
    return <MappingMethodBlankDark />;
  }
  if (isHovered) {
    return <MappingMethodBlankLightHovered />;
  }
  return <MappingMethodBlankLight />;
};
